import { projectSettings } from '../ProjectSettings.js';
import { dirname } from './dirname.js';
import { isUUID } from './isUUID.js';
import { hasPrefix, isHash, isURL, joinPath } from './url.js';
export const PREFIX_API = '/api/';
export const FILE_STORAGE_API = `${PREFIX_API}v1/storage`;
export const adjustHref = (router) => (href, basePath) => {
    if ([
        !href,
        isURL(href),
        isHash(href),
        [projectSettings.CDN, PREFIX_API].some((_) => hasPrefix(href, _)),
    ].some(Boolean)) {
        return href;
    }
    if (isUUID(href)) {
        return `${FILE_STORAGE_API}/${href}/attachment`;
    }
    const isRelativeToBase = href?.startsWith('/');
    return joinPath(hasPrefix(href, basePath) ? '' : basePath, isRelativeToBase ? '/' : dirname(router.pathname), href);
};
//# sourceMappingURL=adjustHref.js.map